import { createStore } from "vuex";
import mutations from "./mutations";
// Modules
import User from "./modules/User";
import List from "./modules/List";
import Subscriptions from "./modules/Subscriptions";

const store = createStore({
  mutations,
  modules: {
    User,
    List,
    Subscriptions,
  },
});

export default store;
